import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {RequestMaintenanceComponent} from "./request-maintenance.component";

const routes: Routes = [
  {
    path:"request/:id",
    component: RequestMaintenanceComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RequestMaintenanceRoutingModule { }
